import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Auth.module.css";
import buttonStyles from "../styles/Buttons.module.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const sendCode = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/auth/request-reset`,
        {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );
      if (!res.ok) {
        const { message } = await res.json();
        throw new Error(message);
      }
      setMessage("Código enviado. Te redirigimos a la pantalla de cambio…");
      setTimeout(() => {
        navigate("/reset-password", { state: { email } });
      }, 1500);
    } catch (err) {
      setError(err.message || "Error al enviar el código.");
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <h2 className={styles.title}>Recuperar Contraseña</h2>
        <form onSubmit={sendCode} className={styles.form}>
          <input
            type="email"
            placeholder="Correo electrónico"
            className={styles.inputForgot}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" className={buttonStyles.btnPrimary}>
            Enviar código
          </button>
        </form>
        {message && <p style={{ color: "#00b4d8" }}>{message}</p>}
        {error && <p className={styles.error}>{error}</p>}
      </div>
    </div>
  );
}
